import type { BackendApi } from './api';

export type SalesInvoiceFile = { blob: Blob, fileName: string };

const FALLBACK_FILE_NAME = 'factuur.pdf';

function fileNameFromContentDisposition(header: string | null): string {
    if (!header) {
        return FALLBACK_FILE_NAME;
    }

    const encoded = header.match(/filename\*=UTF-8''([^;]+)/i);
    if (encoded) {
        return decodeURIComponent(encoded[1].trim());
    }

    const plain = header.match(/filename="?([^";]+)"?/i);
    return plain ? plain[1].trim() : FALLBACK_FILE_NAME;
}

async function toSalesInvoiceFile(response: Response): Promise<SalesInvoiceFile> {
    if (!response.ok) {
        throw new Error(`Failed to load invoice file: ${response.statusText}`);
    }

    return {
        blob: await response.blob(),
        fileName: fileNameFromContentDisposition(response.headers.get('content-disposition')),
    };
}

export async function fetchSalesInvoiceFile(
    api: BackendApi,
    path: string,
    queryParams: Record<string, string>,
): Promise<SalesInvoiceFile> {
    return await toSalesInvoiceFile(await api.get(path, queryParams));
}

export async function postForSalesInvoiceFile(
    api: BackendApi,
    path: string,
    body: object,
): Promise<SalesInvoiceFile> {
    return await toSalesInvoiceFile(await api.post(path, body));
}
